(function($, document, window) {
    'use strict';

    $(function() {
        const $gallery = $( '.js-image-gallery' );

        $gallery.each( function() {
            const prevEl = $( this ).parent().find( '.js-image-gallery-nav-prev' ).toArray();
            const nextEl = $( this ).parent().find( '.js-image-gallery-nav-next' ).toArray();

            const swiper = new Swiper( this, {
                direction: 'horizontal',
                slidesPerView: 1.125,
                spaceBetween: 16,
                grabCursor: true,

                breakpoints: {
                    460: { slidesPerView: 1.25 },
                    580: { slidesPerView: 1.5 },
                    768: { slidesPerView: 2.25 },
                    1024: { slidesPerView: 3.5 },
                },

                navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                }
            } );
        } );
    });
})(jQuery, document, window);
